<mat-form-field [appearance]="appearance!">
  <mat-icon matPrefix *ngIf="icon">
    {{ icon }}
  </mat-icon>
  <mat-label>{{ label }}</mat-label>
  <input 
    type="text" 
    matInput 
    currencyMask
    [options]="moneyOptions || {}"
    [formControlName]="name">
</mat-form-field>